export default "/assets/images/wcf-v1.png?e75730cfb2d50e234faf9cf678a3c4fa";